import classNames from 'classnames';
import React from 'react';
import styles from './FlexColumn.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  gap?: 'none' | 'small' | 'medium' | 'large';
}
const FlexColumn = (props: Props) => {
  const { children, gap = 'none', ...rest } = props;
  const className = classNames(styles.flexColumn, styles[`gap-${gap}`], rest.className);
  return (
    <div {...rest} className={className}>
      {children}
    </div>
  );
};

export default FlexColumn;
